// const ContentRenderer = ({ blocks, currentLang }) => {
//     const getLocalizedContent = (content) => {
//         return typeof content === 'object'
//             ? content[currentLang] || content.en
//             : content;
//     };

//     return blocks.map((block, index) => {
//         const localizedContent = getLocalizedContent(block.content);

//         switch (block.type) {
//             case 'title':
//                 return (
//                     <h3 key={index} className='article__title' id={`title-${index}`}>
//                         {localizedContent}
//                     </h3>
//                 );

//             case 'subtitle':
//                 return (
//                     <h4 key={index} className='article__subtitle' id={`subtitle-${index}`}>
//                         {localizedContent}
//                     </h4>
//                 );

//             case 'paragraph':
//                 return (
//                     <p key={index} className='article__text'>
//                         {localizedContent}
//                     </p>
//                 );

//             case 'list':
//                 return (
//                     <ul key={index} className='article__list'>
//                         {block.items.map((item, itemIndex) => (
//                             <li key={itemIndex} className='article__list__item'>
//                                 {getLocalizedContent(item)}
//                             </li>
//                         ))}
//                     </ul>
//                 );

//             case 'image':
//                 return (
//                     <img
//                         key={index}
//                         src={block.src}
//                         alt={getLocalizedContent(block.alt)}
//                         className="article__image"
//                         loading="lazy"
//                     />
//                 );

//             default:
//                 return null;
//         }
//     });
// };

// export default ContentRenderer;





import { IMAGES_BASE_URL } from '../../../config/constants';

const ContentRenderer = ({ blocks, currentLang }) => {
    const getLocalizedContent = (content) => {
        return typeof content === 'object'
            ? content[currentLang] || content.en
            : content;
    };

    return blocks.map((block, index) => {
        const localizedContent = getLocalizedContent(block.content);

        switch (block.type) {
            case 'title':
                return (
                    <h3 key={index} className='article__title' id={`title-${index}`}>
                        {localizedContent}
                    </h3>
                );

            case 'subtitle':
                return (
                    <h4 key={index} className='article__subtitle' id={`subtitle-${index}`}>
                        {localizedContent}
                    </h4>
                );

            case 'paragraph':
                return (
                    <p key={index} className='article__text'>
                        {localizedContent}
                    </p>
                );

            case 'list':
                return (
                    <ul key={index} className='article__list'>
                        {block.items.map((item, itemIndex) => (
                            <li key={itemIndex} className='article__list__item'>
                                {getLocalizedContent(item)}
                            </li>
                        ))}
                    </ul>
                );

            case 'image':
                const imageUrl = block.src?.startsWith('http') 
                    ? block.src 
                    : `${IMAGES_BASE_URL}${block.src}`;
                
                return (
                    <img
                        key={index}
                        src={imageUrl}
                        alt={getLocalizedContent(block.alt)}
                        className="article__image"
                        loading="lazy"
                    />
                );

            default:
                return null;
        }
    });
};

export default ContentRenderer;